"use client";

import { GenericListPage, type GenericListConfig } from "@admin/_components/generic-list-page";

const config: GenericListConfig = {
  title: "Video Management",
  subtitle: "Manage videos",
  listEndpoint: "videomanagement/video-list",
  countEndpoint: "videomanagement/video-list-count",
  deleteEndpoint: "videomanagement/video-management-delete",
  statusEndpoint: "videomanagement/video-status-change",
  addPath: "/admin/videos/add",
  editPath: "/admin/videos/edit",
  addButtonLabel: "+ Add Video",
  previewEndpoint: "videomanagement/video-data-fetch",
  previewFields: [
    { key: "title", label: "Title" },
    { key: "description", label: "Description" },
    { key: "priority", label: "Priority" },
    { key: "status", label: "Status", type: "badge" },
    { key: "created_on", label: "Created At", type: "date" },
    { key: "updated_on", label: "Updated At", type: "date" },
    { key: "videos", label: "Video Entries", type: "videos" },
  ],
  columns: [
    { key: "title", label: "Title", sortable: true },
    { key: "description", label: "Description" },
    { key: "priority", label: "Priority", sortable: true },
    { key: "status", label: "Status", type: "status" },
    { key: "created_on", label: "Created At", type: "date", sortable: true },
    { key: "updated_on", label: "Updated At", type: "date" },
  ],
  searchFields: [
    { label: "Title", field: "title" },
    { label: "Priority", field: "priority", placeholder: "Search by priority..." },
  ],
  filterFields: [
    {
      label: "Status",
      field: "status",
      values: [
        { val: "1", name: "Active" },
        { val: "0", name: "Inactive" },
      ],
    },
  ],
};

export default function VideosPage() {
  return <GenericListPage config={config} />;
}
